const ListIcon = ({ color = "var(--primary700)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon">
        <path
          id="Vector"
          d="M5 7H19C19.6 7 20 6.6 20 6C20 5.4 19.6 5 19 5H5C4.4 5 4 5.4 4 6C4 6.6 4.4 7 5 7ZM5 13H19C19.6 13 20 12.6 20 12C20 11.4 19.6 11 19 11H5C4.4 11 4 11.4 4 12C4 12.6 4.4 13 5 13ZM5 19H19C19.6 19 20 18.6 20 18C20 17.4 19.6 17 19 17H5C4.4 17 4 17.4 4 18C4 18.6 4.4 19 5 19Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default ListIcon;
